export default __webpack_public_path__ + "static/media/Add_button.ce0bc0bd.svg";